<header class="auth-layout-header">
  <img
    alt=""
    width="119"
    height="34"
    src="/assets/images/logo.svg"
  />
</header>

<main class="auth-layout-content">
  <router-outlet />
</main>
